import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class SalesByCategoryReportData extends ReportData<SalesByCategoryReportData> {
    @collection() groupBy: string[] = ["none"];
    @field reportType: string = "SIMPLE";
    @field exclusive: boolean = true;
    @field summary: boolean = true;
    @field hidezero: boolean = true;
}
